export default __webpack_public_path__ + "static/media/ic_change_password.16c0da6b.svg";